import {gettext, interpolate} from 'topmeteo/utils/i18n';

const AOPALabel = gettext('AOPA Membership');
const Label = gettext('Voucher: %(code)s');

const getLabel = (voucher, AOPACode) => voucher.code === AOPACode ? AOPALabel : interpolate(Label, voucher);

const className = 'voucher';

const isAvailable = ({voucher}) => Boolean(voucher);

const getProps = ({voucher, AOPACode}) => ({
    label: getLabel(voucher, AOPACode),
});

export default {className, isAvailable, getProps};
